@if (hasDecorations()) {
  <div class="config-container shadow mt-4">
    <h4
      (click)="toggleCollapse(SubStepEnum.Decors)"
      [ngClass]="{ active: subStep === SubStepEnum.Decors }"
      class="title configurator-subtitle collapse-button">
      <span>{{ 'fence.materials.decorations' | translate }}</span>
      <span class="title-count">{{ decorations?.length }} {{ 'fence.materials.available-decorations' | translate }}</span>
    </h4>
    @if (!configuration.hasValidQuotation && !isDecorationsValid) {
      <span class="disabled-product pt-1 ml-4">{{ disableMessage }}</span>
    }

    @if (configuration.hasValidQuotation && !isDecorationsValid) {
      <span class="disabled-with-quotation-product pt-1 ml-4">{{ 'fence.materials.valid-quotation-message' | translate }}</span>
    }

    @if (subStep === SubStepEnum.Decors) {
      <div class="collapse-block">
        <div class="decoration-form-row">
          <div class="decoration-form-group">
            <ng-fence-side-panel-count></ng-fence-side-panel-count>
          </div>
        </div>
        <button (click)="deleteAllDecorations()" class="decoration-delete">
          {{ 'fence.materials.delete-decorations' | translate }}
        </button>
        <div class="decoration-container">
          @for (decoration of decorations; track decoration.id) {
            <div [ngClass]="{disabled: decoration.isDisabled}" class="decoration-card">
              <img [src]="baseImgURL + decoration.icon" alt="decoration-img" class="decoration-img" />
              <div class="decoration-content">
                @if (currentLang === 'fr') {
                  <p class="decoration-title">{{ decoration.nameFr }}</p>
                } @else {
                  <p class="decoration-title">{{ decoration.nameEn }}</p>
                }

                <!-- Horizontal -->
                @if (hasHorizontalDecorations() && decoration.canBeHorizontal) {
                  <div class="decoration-form-row">
                    <div class="decoration-form-group">
                      <input
                        (change)="addDecoration('horizontal', decoration)"
                        [checked]="isDecorationChecked('horizontal', decoration)"
                        [id]="'decoration' + decoration.id + 'horizontal'"
                        type="checkbox" />
                      <label [for]="'decoration' + decoration.id + 'horizontal'">{{
                          'fence.materials.horizontal' | translate
                        }}</label>
                    </div>
                    <div class="decoration-form-group form-row">
                      <div class="form-label">
                        <label [for]="'decoration' + decoration.id + 'horizontal_qty'">{{
                            'fence.materials.quantity' | translate
                          }}</label>
                      </div>
                      <div class="form-input">
                        <input
                          (change)="changeDecorationQuantity('horizontal', decoration, null, $event)"
                          [disabled]="!isDecorationChecked('horizontal', decoration)"
                          [id]="'decoration' + decoration.id + 'horizontal_qty'"
                          [max]="maxHorizontalElement(decoration)"
                          [value]="getDecorationQuantity('horizontal', decoration, null)"
                          autocorrect="off"
                          min="0"
                          spellcheck="false"
                          type="number" />
                      </div>
                    </div>
                  </div>
                }

                <!-- Vertical -->
                @if (hasVerticalDecorations() && decoration.canBeVertical) {
                  <div class="decoration-form-row">
                    <div class="decoration-form-group">
                      <input
                        (change)="addDecoration('vertical', decoration)"
                        [checked]="isDecorationChecked('vertical', decoration)"
                        [id]="'decoration' + decoration.id + 'vertical'"
                        type="checkbox" />
                      <label [for]="'decoration' + decoration.id + 'vertical'">{{
                          'fence.materials.vertical' | translate
                        }}</label>
                    </div>
                    <div class="decoration-form-group form-row">
                      <div class="form-label">
                        <label [for]="'decoration' + decoration.id + 'vertical_qty'">{{
                            'fence.materials.total-quantity' | translate
                          }}</label>
                      </div>
                      <div class="form-input">
                        <input
                          [id]="'decoration' + decoration.id + 'vertical_qty'"
                          [value]="getDecorationQuantity('vertical', decoration, null)"
                          autocorrect="off"
                          disabled="true"
                          min="0"
                          spellcheck="false"
                          type="number" />
                      </div>
                    </div>
                  </div>
                }

                @if (isDecorationChecked('vertical', decoration)) {
                  <div class="decoration-form-row justify-content-end">
                    <div class="decoration-form-group">
                      @for (side of configuration.sides; track side.id) {
                        <div class="decoration-form-group form-row mb-2 pr-0">
                          <div class="form-label">
                            <label [for]="'decoration' + side.id + '_' + decoration + 'vertical_qty'">
                              {{ 'fence.materials.side' | translate }} {{ side.id }}
                            </label>
                          </div>
                          <div class="form-input">
                            <input
                              (change)="changeDecorationQuantity('vertical', decoration, side.id, $event)"
                              [disabled]="!isDecorationChecked('vertical', decoration) || maxVerticalElement(decoration, side) <= 0"
                              [id]="'decoration' + side.id + '_' + decoration.id + 'vertical_qty'"
                              [max]="maxVerticalElement(decoration, side)"
                              [value]="getDecorationQuantity('vertical', decoration, side)"
                              autocorrect="off"
                              min="0"
                              spellcheck="false"
                              type="number" />
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
          } @empty {
            <ng-casto-loader></ng-casto-loader>
          }
        </div>
      </div>
    }
  </div>
}
